import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/moodbuster-short-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-03af6d05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "change-password" }
const _hoisted_2 = {
  id: "change-password-container",
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "moodbuster short logo"
  })
], -1))
const _hoisted_4 = { class: "col-6 change-password-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ChangePasswordForm = _resolveComponent("ChangePasswordForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { menus: false }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ChangePasswordForm)
      ])
    ])
  ]))
}